import { type MouseEventHandler, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Link } from "ui/link";

export interface RouterLinkProps {
  to: string;
  state?: unknown;
  id?: string;
  className?: string;
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  sx?: SxProps<Theme>;
  "data-testid"?: string;
}

const RouterLink = ({
  to,
  state,
  id,
  className,
  children,
  onClick,
  sx,
  "data-testid": dataTestId,
}: RouterLinkProps) => (
  <Link
    component={NavLink}
    to={to}
    state={state}
    data-testid={dataTestId ?? `router-link-${id}`}
    size="small"
    className={className}
    onClick={onClick}
    sx={sx}>
    {children}
  </Link>
);

export default RouterLink;
